module.exports = __webpack_public_path__ + "static/media/TTNorms-MediumItalic.7cda2fd6.otf";